import useMount from '@src/utils/hooks/use-mount';
import { observable } from 'mobx';
import BaseStore from '@src/utils/store/base-store';
import { useLayerData } from '@src/utils/hooks/use-layer-data';
import { useEffect } from 'react';
class AdvantageStore extends BaseStore {
  constructor(options = {}) {
    super();
    Object.assign(this, options);
  }

  @observable mainStore;

  @observable list = [];

  use() {
    super.use();
    const layerData = useLayerData('part2');

    useEffect(
      () => {
        if (layerData) {
          this.list = layerData.typeList;
        }
      },
      [layerData]
    );
    useMount(() => {});
  }
}

export default AdvantageStore;
